module.exports = __webpack_public_path__ + "img/tab.4d58667e.jpg";